var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-lg-10 col-md-8 col-12 main"},[_c('div',{ref:"masonry",staticClass:"masonry-js row"})])
}
var staticRenderFns = []

export { render, staticRenderFns }